import util from './util';

async function notify(title, message = '', type = 0, errorElements = null) {
    const msg = message.replace(/\.$/, '').trim();
    if (!msg) return;

    const numType = Number(type);
    const notification = document.getElementById('notification');
    const notificationMessage = document.getElementById('notificationMessage');
    notificationMessage.innerHTML = msg;
    util.showElement(document.getElementById('notificationContainer'));

    if (numType === -10) {
        // Set toast message
        const toast = document.getElementById('toastMessage-danger');
        toast.innerText = msg;

        // bootstrap is imported into the browser.
        // eslint-disable-next-line no-undef
        new bootstrap.Toast(document.querySelector('#toast-danger')).show();
        $('#toast-danger').on('hidden.bs.toast', () => {
            util.showElement(document.getElementById('notificationContainer'), false);
        });
    } else if (numType < 0) {
        notification.classList.add('alert-danger');
        util.showElementWithFlex(notification);
        notification.classList.add('flex-wrap');

        if (errorElements) {
            const notificationErrorsContainer = document.getElementById('notificationErrorsContainer');
            util.showElementWithFlex(notificationErrorsContainer);
            document.getElementById('notificationErrors').innerHTML = errorElements.outerHTML;
        }
    } else if (numType === 0) {
        // Set toast message
        const toast = document.getElementById('toastMessage-success');
        toast.innerText = msg;

        // bootstrap is imported into the browser.
        // eslint-disable-next-line no-undef
        new bootstrap.Toast(document.querySelector('#toast-success')).show();
        $('#toast-success').on('hidden.bs.toast', () => {
            util.showElement(document.getElementById('notificationContainer'), false);
        });
    } else {
        notification.classList.add('alert-warning');
        notification.classList.add('flex-wrap');
        util.showElementWithFlex(notification);
    }
}

function notifyOnVisit(title, message = '', type = 0) {
    window.sessionStorage.notification = JSON.stringify({
        title,
        message,
        type,
    });
}

function hide() {
    const notificationContainer = document.getElementById('notificationContainer');
    const notificationElem = document.getElementById('notification');
    if (notificationElem) {
        notificationElem.classList.remove('flex-wrap');
        util.showElement(notificationElem, false);
    }
    util.showElement(notificationContainer, false);
}

const notification = { hide, notify, notifyOnVisit };
export default notification;
window.notification = notification;

if (window.sessionStorage) {
    window.sessionStorage.notification = sessionStorage.notification || '';

    if (window.sessionStorage.notification) {
        try {
            const n = JSON.parse(window.sessionStorage.notification);
            window.notification.notify(n.title, n.message, n.type);
        } catch (e) {
            // ignore
        }

        window.sessionStorage.notification = '';
    }
}

function init() {
    util.each(document.querySelectorAll('.notification-close'), (el) => {
        el.addEventListener('click', (evt) => {
            evt.preventDefault();
            window.notification.hide();
        });
    });
}

document.addEventListener('DOMContentLoaded', () => init());
